import React, { useState } from 'react'
import QuizHeader from '../../Components/QuizHeader'
import styles from "./Styles/CostPackage.module.css"
import budget from "../../Assets/budget.png"
import premium from "../../Assets/premium.png"
import luxury from "../../Assets/luxury.png"
import { TiMinus, TiPlus } from 'react-icons/ti'
import { BsCheck, BsCheck2, BsChevronRight } from 'react-icons/bs'
import { useNavigate } from 'react-router-dom'
import Button from '../../Components/Button'

export default function CostPackage() {
  const navigate = useNavigate()


  const [selectedItem, setSelectedItem] = useState('')
  const [selectedSubItem, setSelectedSubItem] = useState('')
  const [data, setData] = useState([
    {
      item: 'Civil & Interior Finishes',
      subItems: [
        {
          name: 'Base Civil Works',
          includes: [
            'Chemical Water Proofing',
            'Anti Termite Treatment',
            'Pest Control'
          ]
        },
        {
          name: 'Structure & Partition',
          includes: [
            'Chemical Water Proofing',
            'Anti Termite Treatment',
            'Pest Control'
          ]
        },
        {
          name: 'Flooring',
          includes: [
            'Chemical Water Proofing',
            'Anti Termite Treatment',
            'Pest Control'
          ]
        },
        {
          name: 'Ceiling Work',
          includes: [
            'Chemical Water Proofing',
            'Anti Termite Treatment',
            'Pest Control'
          ]
        },
        {
          name: 'Wall Finishes',
          includes: [
            'Chemical Water Proofing',
            'Anti Termite Treatment',
            'Pest Control'
          ]
        },
        {
          name: 'Doors',
          includes: [
            'Chemical Water Proofing',
            'Anti Termite Treatment',
            'Pest Control'
          ]
        },
        {
          name: 'Paint',
          includes: [
            'Chemical Water Proofing',
            'Anti Termite Treatment',
            'Pest Control'
          ]
        }
      ]
    },
    {
      item: 'Electricals, AC, Plumbing, Data',
      subItems: []
    },
    {
      item: 'Furniture',
      subItems: []
    },
    {
      item: 'Lights,Appliances & Decor',
      subItems: []
    }
  ])

  return (
    <React.Fragment>
      <QuizHeader step5 />
      <div className={styles.container}>
      <header>
          <h2>Cost Package</h2>
          <h3>Choose your plan.</h3>
        </header>


        <table className={styles.table}>
          <thead>
            <tr>
              <th style={{border:'none'}}></th>
              <th><img src={budget} /></th>
              <th><img src={premium} /></th>
              <th><img src={luxury} /></th>
            </tr>
            <tr className={styles.secHeader}>
              <th>Parameters</th>
              <th style={{color:'#161C45'}}>Basic</th>
              <th style={{color:'#161C45'}}>Premuim</th>
              <th style={{color:'#161C45'}}>Luxury</th>
            </tr>
            <tr className={styles.thirdHeader}>
              <th style={{fontSize:14,fontWeight:400}}>Pricing</th>
              <th>Rs 1800 - Rs 2200/ sq ft</th>
              <th>Rs 1800 - Rs 2200/ sq ft</th>
              <th>Rs 1800 - Rs 2200/ sq ft</th>
            </tr>
          </thead>
          <tbody>

            {data.map(i => {
              return <tr>
              <td>
                <div onClick={()=>{
                  if(selectedItem == ''){
                    setSelectedItem(i.item)
                    setSelectedSubItem('')
                  } else {
                    setSelectedItem('')
                    setSelectedSubItem('')
                  }
                  }} className={styles.itemHeader}>
                  <p>{i.item}</p>
                  {selectedItem == i.item ? <TiMinus size={22} /> : <TiPlus size={22} />}
                </div>

                {(i.subItems.length !== 0 && selectedItem == i.item) ? <div className={styles.itemBody}>
                  {i.subItems.map(s => {
                    return <div onClick={()=>setSelectedSubItem(s.name)} className={styles.subItem}>
                    <p>{s.name}</p>
                    <BsChevronRight />
                  </div>
                  })}
                </div> : null}
              </td>


              <td>
              <div className={styles.checkMark}><BsCheck /></div>
              {(selectedItem == i.item && selectedSubItem !== '') ? <div className={styles.includes}>
                  <h3>Includes</h3>
                  {i.subItems.map(sub => {
                    return sub.includes.map(inc => {
                      if(sub.name == selectedSubItem){
                      return <ul>
                        <li>{inc}</li>
                    </ul>
                    }
                    })
                  })}
                </div> : null}
              </td>

              <td>
              <div className={styles.checkMark}><BsCheck /></div>
              {(selectedItem == i.item && selectedSubItem !== '') ? <div className={styles.includes}>
                  <h3>Includes</h3>
                  {i.subItems.map(sub => {
                    return sub.includes.map(inc => {
                      if(sub.name == selectedSubItem){
                      return <ul>
                        <li>{inc}</li>
                    </ul>
                    }
                    })
                  })}
                </div> : null}
              </td>

              <td>
              <div className={styles.checkMark}><BsCheck /></div>
              {(selectedItem == i.item && selectedSubItem !== '') ? <div className={styles.includes}>
                  <h3>Includes</h3>
                  {i.subItems.map(sub => {
                    return sub.includes.map(inc => {
                      if(sub.name == selectedSubItem){
                      return <ul>
                        <li>{inc}</li>
                    </ul>
                    }
                    })
                  })}
                </div> : null}
              </td>

              
            </tr>
            })}
          </tbody>
        </table>

        <div style={{display:'flex',justifyContent:'center'}}>
        <Button height={56} width={320} onClickHandler={()=>navigate('/quiz/uploadlayout')} radius={10} mt={32} title="Continue" />
        </div>
      </div>
    </React.Fragment>
  )
}
